import { gql } from "@apollo/client";

export const GET_ALL_CLIENTES = gql`
query GetAllClientes(
    $skip: Int
    $take: Int
    $where: Clientes_IFilterInput
) {
    allClientesPaging(
        skip: $skip
        take: $take
        where: $where
    )
        {
            items {
                iD
                cod_Cliente
                nom_com
                cUIT
                estado
                cod_Delegacion
                condicionIVA
                domicilio
                cP
                localidad
                provincia
                pais
                cod_condicion
                condicionpago
                bP
                bE
                cod_Ramo
            }
                totalCount
        }
    }
`;

export const adaptFinanciador = (financiador) => {
  return {
    codigoCliente: financiador?.cod_Cliente,
    nombre: financiador?.nom_com,
    condicionPago: financiador?.condicionpago,
    codigoRamo: financiador?.cod_Ramo
  };
};

export const adaptFinanciadoresArray = (
allClientes) =>
{
  return structuredClone(allClientes)?.
  map((financiador) => adaptFinanciador(financiador));
};